import React from "react";
import { Box, Typography } from "@mui/material";
import SelectCustomerImg from '../../../assets/images/select-customer.png';
import '../../../styles/pages/admin/selectCustomer.scss'
import { useTranslation } from "react-i18next";

const SelectCustomerPage = () => {
    const { t } = useTranslation();
    return (
        <Box display={'flex'} justifyContent={'center'} alignItems={"center"} flexDirection={'column'} className="no-data-image">
            <Typography component={'p'}
                sx={{ pb: '1rem', fontSize: '1.5rem', fontWeight: 500, textAlign: 'center' }}
                className="select-customer-text"
            >{t('select_the_customer')}</Typography>
            <div className="image-container">
                <img src={SelectCustomerImg} alt="Select-Customer Image" className="responsive-image" />
            </div>
        </Box>
    )
}

export default SelectCustomerPage;